export default __webpack_public_path__ + "static/media/supporter_token.ec177109.png";